import { Component, Input } from "@angular/core"

@Component({
  selector: "ag-divider",
  standalone: false,
  templateUrl: "./ag-divider.component.html",
  styleUrl: "./ag-divider.component.scss",
})
export class AgDividerComponent {
  @Input() type: AgDividerType = "horisontal"
  @Input() alignment: Alignment = "center"
  @Input() length: string = "100%"
  @Input() withOr: boolean = false
  @Input() color: string = "#dfdfdf"
}

export type Alignment = "flex-start" | "center" | "flex-end"
export type AgDividerType = "horisontal" | "vertical"
